import { useQuery } from "@tanstack/react-query";
import { getNotificationCount } from "apis/notification";
import QUERY_KEYS from "config/queryKey";

const useNotificationCountQuery = (isUser?: boolean) => {
  return useQuery({
    queryKey: [QUERY_KEYS.notifications, QUERY_KEYS.notificationCount],
    queryFn: getNotificationCount,
    enabled: isUser === true,
  });
};

export default useNotificationCountQuery;
